(function () {
  if (window.customElements && customElements.get('product-tile-track')) return;

  class ProductTileTrack extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-product-tiles-track]');
      this.count = parseInt(this.getAttribute('data-count'), 10) || 0;
      this.duration = parseInt(this.getAttribute('data-duration'), 10) || 520;

      if (!this.track || this.count < 2) return;

      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-product-tiles-step]'));
      this.index = this.count;
      this.moving = false;

      this.handleClick = this.handleClick.bind(this);
      this.finish = this.finish.bind(this);

      this.buttons.forEach((button) => button.addEventListener('click', this.handleClick));
      this.track.addEventListener('transitionend', this.finish);

      this.apply(false);
    }

    disconnectedCallback() {
      if (!this.track) return;

      clearTimeout(this.timer);
      this.buttons.forEach((button) => button.removeEventListener('click', this.handleClick));
      this.track.removeEventListener('transitionend', this.finish);
    }

    handleClick(event) {
      event.preventDefault();

      if (this.moving) return;

      this.moving = true;
      this.index += parseInt(event.currentTarget.getAttribute('data-product-tiles-step'), 10);
      this.apply(true);

      clearTimeout(this.timer);
      this.timer = setTimeout(this.finish, this.duration + 100);
    }

    finish() {
      if (!this.moving) return;

      clearTimeout(this.timer);
      this.moving = false;

      if (this.index >= this.count * 2) {
        this.index -= this.count;
      } else if (this.index < this.count) {
        this.index += this.count;
      } else {
        return;
      }

      this.apply(false);
    }

    apply(animate) {
      const offset = (this.index * -100) / (this.count * 3);

      if (animate) {
        this.track.style.transform = 'translateX(' + offset + '%)';
        return;
      }

      this.track.style.transitionDuration = '0s';
      this.track.style.transform = 'translateX(' + offset + '%)';
      void this.track.offsetWidth;
      this.track.style.transitionDuration = '';
    }
  }

  customElements.define('product-tile-track', ProductTileTrack);
})();
